<app-phx-input-number
    class="w-full"
    [formControl]="formControl"
    [formlyAttributes]="field"
    [autofocus]="props?.autofocus"
    [placeholder]="props?.placeholder"
    [required]="props?.required"
    [dataTestId]="props?.dataTestId"
    [minFractionDigits]="minFractionDigits()"
    [maxFractionDigits]="maxFractionDigits()"
    [minValue]="props?.minValue"
    [maxValue]="props?.maxValue"
    [upDownButtons]="props?.upDownButtons"
/>
